// connect-result.ts — (audit 10-17 B-F3) a connect's result as the popup reports it, and the one a connect that finished in
// a full window keeps for the page. Pure (no API client), so its rule is tested on its own.
export const CONNECT_RESULT_KEY = "tf-connect-result";
/** `channel`: the platform this connect was for, so each section reads only its own result */
export interface ConnectResult { connected?: string; status?: string; error?: string; channel?: string }

/** (audit 10-17 B-F3) the result a connect that finished in this window (no popup) kept for the page — taken (removed)
 *  only by the section of its platform. One kept before results named their platform is TikTok's (the only one then). */
export function takeKeptConnectResult(channel: string, store: Pick<Storage, "getItem" | "removeItem"> = sessionStorage): ConnectResult | null {
  try {
    const kept = store.getItem(CONNECT_RESULT_KEY);
    if (!kept) return null;
    const r = JSON.parse(kept) as ConnectResult;
    if ((r.channel ?? "tiktok") !== channel) return null;
    store.removeItem(CONNECT_RESULT_KEY);
    return r;
  } catch { return null; }   // catch-reason: storage off, or a kept value that isn't JSON — nothing to show
}

